import { Add } from '@mui/icons-material';
import { SxProps, Theme, Typography, useTheme } from '@mui/material';

import { Card } from 'components';
import strings from 'constants/index';

import { permissionsCardStyles } from './PermissionsCard.styles';

interface AddNewPermissionCardProps {
  onClick: () => void;
  sx?: SxProps<Theme>;
}

const AddNewPermissionCard = ({ onClick, sx }: AddNewPermissionCardProps) => {
  const theme = useTheme();

  return (
    <Card
      data-testid="add-new-permission-card"
      sx={{ ...permissionsCardStyles.card, ...(sx ? sx : {}) }}
      onClick={onClick}
      contentSX={{
        ...permissionsCardStyles.addCard,
        background: theme.palette.action.hover,
        '&:hover': {
          background: theme.palette.action.disabledBackground,
        },
      }}
    >
      <Add />
      <Typography variant="h6" data-testid="add-new-permissions-card" align="center">
        {strings.add_new_permission}
      </Typography>
    </Card>
  );
};

export default AddNewPermissionCard;
